<mat-progress-spinner
  class="custom-spinner"
  [diameter]="diameter"
  [mode]="mode"
  [strokeWidth]="strokeWidth"
  [value]="value"
  [class]="theme"
></mat-progress-spinner>
